module.exports = __webpack_public_path__ + "static/media/ticketlogger.4e5d51ba.mp4";